import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-115">
      <div className="max-w-[760px] mx-auto" data-id="element-116">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-12" data-id="element-117">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8,
          rotate: -10
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} className="flex-shrink-0 relative w-[200px] h-[200px] rounded-full bg-gradient-to-br from-gold to-gold-dark border-4 border-gold-border shadow-[0_8px_32px_rgba(244,208,63,0.4)] flex items-center justify-center" data-id="element-118">
            <div className="absolute inset-2 border border-white/30 rounded-full border-dashed" data-id="element-119"></div>
            <div className="flex flex-col items-center justify-center text-dark text-center z-10" data-id="element-120">
              <span className="text-[14px] font-bold tracking-widest uppercase mb-1" data-id="element-121">
                Garantía
              </span>
              <span className="text-[64px] font-black leading-none my-1" data-id="element-122">
                7
              </span>
              <span className="text-[18px] font-bold uppercase leading-none mb-2" data-id="element-123">
                Días
              </span>
              <span className="text-[11px] font-bold tracking-wider uppercase bg-dark text-gold px-2 py-0.5 rounded" data-id="element-124">
                100% Satisfecha
              </span>
            </div>
            <Shield className="absolute top-4 text-dark/20 w-8 h-8" data-id="element-125" />
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex-1 text-center md:text-left" data-id="element-126">
            <h2 className="text-[28px] font-bold text-dark mb-4" data-id="element-127">
              Tu Inversión Está 100% Protegida
            </h2>
            <p className="text-[16px] text-[#555] leading-[1.8] mb-6" data-id="element-128">
              Si en los próximos 7 días no sientes más energía, no notas una
              diferencia en tus antojos, o simplemente sientes que el protocolo
              no es para ti... Te devuelvo cada centavo de tus $6.36 USD. Sin
              preguntas. Sin formularios. Sin drama.
            </p>

            <ul className="space-y-3 inline-block text-left" data-id="element-129">
              <li className="flex items-center gap-2 text-[15px] text-dark font-medium" data-id="element-130">
                <Check className="w-5 h-5 text-lime" data-id="element-131" /> Sin preguntas incómodas
              </li>
              <li className="flex items-center gap-2 text-[15px] text-dark font-medium" data-id="element-132">
                <Check className="w-5 h-5 text-lime" data-id="element-133" /> Reembolso en menos de 24
                horas
              </li>
              <li className="flex items-center gap-2 text-[15px] text-dark font-medium" data-id="element-134">
                <Check className="w-5 h-5 text-lime" data-id="element-135" /> El riesgo es 100%
                nuestro
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}